import React, {useState} from 'react';
import {
    TextField,
    Button,
    Container,
    Typography,
    Paper,
    Grid,
    Box,
    Link,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SecurityIcon from '@mui/icons-material/Security';
import ScienceIcon from '@mui/icons-material/Science';
import api from '../api';
import {useNavigate, Link as RouterLink} from 'react-router-dom';

const Login = ({setAuth}) => {
    const [formData, setFormData] = useState({email: '', password: ''});
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/api/accounts/login/', formData);
            localStorage.setItem('token', response.data.token);
            setAuth(true);
            navigate('/profile');
        } catch (error) {
            if (error.response) {
                console.error('Login failed:', error.response.data);
            } else if (error.request) {
                console.error('Login failed: No response from server.', error.request);
            } else {
                console.error('Login failed: Error', error.message);
            }
        }
    };

    return (
        <Container maxWidth="lg">
            <div style={{ maxWidth: "25em", float: "right", marginTop: "3em" }}>
                <Paper elevation={6} sx={{p: 4, borderRadius: 2}}>
                    <Typography variant="h5" component="h2" align="center" gutterBottom>
                        Login
                    </Typography>
                    <Divider sx={{ mb: 3 }} />
                    <form onSubmit={handleSubmit}>
                        <div>
                            <TextField
                                label="Email"
                                name="email"
                                type="email"
                                value={formData.email}
                                onChange={handleChange}
                                fullWidth
                                required
                                variant="outlined"
                            />
                        </div>
                        <div style={{ marginTop: ".5em", marginBottom: "1em" }}>
                            <TextField
                                label="Password"
                                name="password"
                                type="password"
                                value={formData.password}
                                onChange={handleChange}
                                fullWidth
                                required
                                variant="outlined"
                            />
                       </div>
                       <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            size="large"
                            sx={{ mt: 1, py: 1.5 }}
                        >
                            Login
                        </Button>
                        <Box display="flex" justifyContent="center" mt={1} style={{ marginTop: "1em" }}>
                            <Typography variant="body2">
                                No account yet? <Link component={RouterLink} to="/register">Register here</Link>
                            </Typography>
                        </Box>
                    </form>
                </Paper>

                {/* Footer Links (Below Form) */}
                <Box mt={3} display="flex" justifyContent="center" gap={3}>
                    <Link component={RouterLink} to="/impressum" color="text.secondary" variant="body2">
                        Impressum
                    </Link>
                    <Link component={RouterLink} to="/datenschutz" color="text.secondary" variant="body2">
                        Datenschutzerklärung
                    </Link>
                </Box>
            </div>

            {/* --- 2. Welcome Text Section (Bottom on Mobile, Left on Desktop) --- */}
            <Grid
                container
                spacing={4}
                alignItems="center"
                sx={{minHeight: '70vh'}}
                direction={{ xs: 'column', md: 'row-reverse' }}
                style={{ display: "block", float: "left", maxWidth: "calc(100% - 25em)", minWidth: "21em", marginTop: "3em" }}
            >
                <Grid item xs={12} md={8}>
                    <Box sx={{ pr: { md: 6 } }}>
                        <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: '#27552c' }}>
                            Contribute to Science.
                        </Typography>
                        <Typography variant="h5" color="text.secondary" gutterBottom>
                            Simple. Secure. Anonymous.
                        </Typography>

                        <Box mt={3}>
                            <Typography component="p">
                                The Observatorium connects you with paid and unpaid studies from the Ruhr University
                                Bochum.
                                Create your profile once, and receive invitations tailored specifically to you.
                            </Typography>
                        </Box>

                        <List>
                            <ListItem disableGutters>
                                <ListItemIcon>
                                    <ScienceIcon color="primary"/>
                                </ListItemIcon>
                                <ListItemText
                                    primary="Relevant Opportunities"
                                    secondary="Receive invites only for studies that match your profile."
                                />
                            </ListItem>
                            <ListItem disableGutters>
                                <ListItemIcon>
                                    <SecurityIcon color="primary"/>
                                </ListItemIcon>
                                <ListItemText
                                    primary="Privacy First"
                                    secondary="Your data is hosted at RUB. Researchers never see your personal details, only anonymous codes."
                                />
                            </ListItem>
                            <ListItem disableGutters>
                                <ListItemIcon>
                                    <CheckCircleOutlineIcon color="primary"/>
                                </ListItemIcon>
                                <ListItemText
                                    primary="No Tracking"
                                    secondary="We respect your digital privacy. No tracking cookies, no third-party analytics."
                                />
                            </ListItem>
                        </List>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Login;
